/**
 * ROC 7
 * Copyright 2017 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Upcharges/UpchargeRegistrationService',[
    'jquery',
    'lodash',
    'global/all'
], function ($, lodash, Roc) {
    'use strict';


    var registeredUpcharges = {};


    function register(code, upchargeObject) {
        registeredUpcharges[code] = upchargeObject;
    }


    function bindUpchargeEvents() {
        _.each(registeredUpcharges, function (upcharge) {
            if (typeof upcharge.bindEvents === "function") {
                upcharge.bindEvents();
            }
        });
    }

    function initForAddToCart() {
        _.each(registeredUpcharges, function (upcharge) {
            if (typeof upcharge.initForAddToCart === "function") {
                upcharge.initForAddToCart();
            }
        });
    }

    function initForCheckout(checkoutViewModel) {
        _.each(registeredUpcharges, function (upcharge) {
            if (typeof upcharge.initForCheckout === "function") {
                upcharge.initForCheckout(checkoutViewModel);
            }
        });
    }

    function preRenderQuickView(viewModel) {
        _.each(registeredUpcharges, function (upcharge) {
            if (typeof upcharge.preRenderQuickView === "function") {
                upcharge.preRenderQuickView(viewModel);
            }
        });
    }

    function populateUpchargeData(upchargeData) {
        _.each(registeredUpcharges, function (upcharge) {
            if (typeof upcharge.populateUpchargeData === "function") {
                upcharge.populateUpchargeData(upchargeData);
            }
        });
    }


    /**
     * A module for making shopping cart api requests related to upcharges.
     * @exports UpchargeRegistrationService
     */
    var UpchargeRegistrationService = {
        register: register,

        bindUpchargeEvents: bindUpchargeEvents,
        initForAddToCart: initForAddToCart,
        initForCheckout: initForCheckout,
        preRenderQuickView: preRenderQuickView,
        populateUpchargeData: populateUpchargeData,
    };

    Roc.Logger.debug('UpchargeRegistrationService.js Loaded:', UpchargeRegistrationService);

    return UpchargeRegistrationService;
});
